import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../../store/actions/authThunks';
import { useFeedbackContext } from '../../../context';
import { LogoutIcon } from '../Icons';

/**
 * LogoutMenuOption Component
 *
 * Renders a logout option with an icon and label. When clicked, it displays a confirmation
 * FeedbackModal (via showModal from the FeedbackContext) to confirm the logout action.
 * Upon confirmation, it dispatches the logout thunk from Redux.
 *
 * Props:
 * - onClose: function to close the parent menu.
 */
const LogoutMenuOption = ({ onClose }) => {
  const dispatch = useDispatch();

  const { showModal } = useFeedbackContext();

  const handleConfirmLogout = () => {
    dispatch(logout());
    if (onClose) onClose();
  };

  const handleLogoutClick = () => {
    showModal({
      variant: 'warning',
      title: 'Confirm Logout',
      copy: 'You’re about to end your session. Do you wish to proceed?',
      buttonMessage: 'Yes, log out',
      onClickButton: handleConfirmLogout,
    });
  };

  return (
    <div className="cursor-pointer flex items-center gap-6 py-4 p-6" onClick={handleLogoutClick}>
      <LogoutIcon />
      <span>Logout</span>
    </div>
  );
};

export default LogoutMenuOption;
